module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"comments:tooltips:btn-delete":"Удалить комментарий"},"en":{"comments:tooltips:btn-delete":"Delete comments"}}')
  delete Component.options._Ctor
}
